export default "__VITE_ASSET__tsdSoKrn__"